import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, deleteSuccess, deleteFailure } from '../../actions/deployments/delete';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* deleteDeploymentData(action) {
  try {
    const { promotion_id } = action.payload;
    
    const response = yield call(
      axios.delete,
      `${config.API_URL}/deployments/${promotion_id}`,
      { headers: getLocalUser() }
    );
    
    yield put(deleteSuccess(response.data));
    
    // Show success message
    yield put({
      type: 'SNACKBAR_SUCCESS_MESSAGE',
      text: 'Deployment deleted successfully'
    });
    
  } catch (error) {
    yield put(Error(error));
    yield put(deleteFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, deleteDeploymentData);
}
